import { createApp } from 'vue'
import App from './App.vue'
import 'awesome-notifications/dist/style.css'

const app = createApp(App)

// Si aún necesitas el contact global:
app.config.globalProperties.$contact = typeof contact !== 'undefined' ? contact : null

// Event bus opcional (puedes usar mitt en Vue 3 como alternativa)
app.config.globalProperties.$eventHub = app

app.mount('#app')
